// extracted by mini-css-extract-plugin
export var container = "_72-0";
export var infoButton = "_72-1";
export var label = "_72-3";
export var labelExpanded = "_72-4";
export var price = "_72-5";
export var priceExpanded = "_72-6";
export var title = "_72-2";